export default "__VITE_ASSET__DKT8XtZ9__"